import { kPhotoMaskOptions } from "../constants";

export function ConvertPhotoMaskSelection(aCmd) {
  var v = aCmd["newvalue"];
  var x = kPhotoMaskOptions.indexOf(v);
  return x;
}
